type UserData = {
  event: string;
  sharetype: string;
};

export interface AnalyticsWindow extends Window {
  _mtm?: UserData[];
}

export const pingMatomo = (eventName: string) => {
  const analyticsWindow: AnalyticsWindow = window;
  analyticsWindow._mtm = analyticsWindow._mtm || [];
  analyticsWindow._mtm.push({
    event: 'share',
    sharetype: eventName,
  });
};

/* Ping Matomo whenever elements are clicked.
 *
 * For an element to be considered it needs a `js-matomo-ping`
 * plus a data-matomo-name attribute. Like:
 *
 * <button class="js-matomo-ping" data-matomo-name="print">Drucken</button>
 */
export const handleMatomoPing = () => {
  const elements = document.querySelectorAll<HTMLElement>('.js-matomo-ping');
  elements.forEach(element => {
    const button = element;
    const value = button.dataset.matomoName;
    if (!value) return;
    element.addEventListener('click', () => {
      pingMatomo(value);
    });
  });
};
